// extracted by mini-css-extract-plugin
module.exports = {"resetButton":"ResetData_resetButton__YTf5u","info":"ResetData_info__oPT3R","spinner":"ResetData_spinner__cH0Vp"};